import { useParams } from "@tanstack/react-router";
import { AnalyticsCatalogContext, catalogSeoQualityTier } from "@/components/analytics-catalog-context";
import { ArtistContent } from "./$id/artist-content";
interface ArtistSearch {
  q?: string;
  type?: string;
  sort?: string;
  format?: string;
  country?: string;
  label?: string[];
  company?: string[];
  year?: number[];
  filter?: ReleaseSearchFilter;
}
import { Route } from "/app/apps/web/src/routes/_app/artist/$id.tsx";
function ArtistRoute() {
  const {
    id
  } = useParams({
    from: "/_app/artist/$id"
  });
  const loaderData = Route.useLoaderData();
  return <>
      <AnalyticsCatalogContext entityType="artist" qualityTier={catalogSeoQualityTier(loaderData.artist)} />
      <ArtistContent id={id} discographyQueryType={loaderData.discographyQueryType} />
    </>;
}
export { ArtistRoute as component };